module.exports = __webpack_public_path__ + "img/konfigurasi_network.385f70a9.svg";